export const normalizeEndTime = (time: string) => time === "00:00:00" ? "24:00:00" : time;